import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-md mx-auto px-5 lg:px-8 py-16">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-neutral-900 mb-6" data-testid="forgot-back">
          <ArrowLeft size={16} /> Back to login
        </Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <div className="h-14 w-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto"><CheckCircle2 size={24} /></div>
            <h1 className="font-display text-3xl font-bold mt-6">Check your inbox</h1>
            <p className="text-neutral-600 mt-2">If an account exists for <span className="font-medium">{email}</span>, we've sent a reset link. It expires in 30 minutes.</p>
            <p className="text-xs text-neutral-500 mt-6">Didn't get it? Check spam, or <button onClick={() => setSent(false)} className="underline">try again</button>.</p>
          </div>
        ) : (
          <>
            <div className="overline mb-3">FORGOT PASSWORD</div>
            <h1 className="font-display text-4xl font-bold tracking-tight mb-2">Reset your password</h1>
            <p className="text-neutral-600 mb-8">Enter the email you signed up with — we'll send a secure reset link.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-sm font-medium">Email</label>
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 w-full h-11 border border-neutral-200 rounded-lg px-3 focus:outline-none focus:ring-2 focus:ring-neutral-900"
                  placeholder="you@org.com" data-testid="forgot-email" autoComplete="email" />
              </div>
              <button disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
                {loading && <Loader2 size={16} className="animate-spin" />} <Mail size={16} /> Send reset link
              </button>
            </form>
            <p className="text-xs text-neutral-500 mt-6">
              Reset by phone (SMS OTP) isn't wired yet — it needs a Twilio account. Ask us to enable it if you'd like.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
